// @ts-nocheck
/**
 * ツインキー状態異常タイプ定義
 *
 * 仕様書: twin_key_status_skill_system_v1.md
 * 設計書: twin_key_phase2_design.md
 */

/**
 * 状態異常タイプ（12種類）
 * - 属性別: 7個（火傷、凍結、麻痺、呪い、時止、毒、虚脱）
 * - 汎用: 5個（スタン、沈黙、攻撃↓、防御↓、速度↓）
 */
export const STATUS_EFFECT_TYPES = {
  // 属性別状態異常（7個）
  BURN: 'BURN',           // 火傷 - 炎属性 - HP5%/ターン
  FREEZE: 'FREEZE',       // 凍結 - 水属性 - 行動不能+被ダメ+25%
  PARALYSIS: 'PARALYSIS', // 麻痺 - 光属性 - 50%で行動失敗
  CURSE: 'CURSE',         // 呪い - 闇属性 - 回復効果50%減
  TIME_STOP: 'TIME_STOP', // 時止 - 未来属性 - 速度-50
  POISON: 'POISON',       // 毒 - 原始属性 - HP3%/ターン（永続）
  EXHAUST: 'EXHAUST',     // 虚脱 - なし属性 - 与ダメ-30%

  // 汎用状態異常（5個）
  STUN: 'STUN',           // スタン - 行動不能（1ターン）
  SILENCE: 'SILENCE',     // 沈黙 - スキル使用不可
  ATK_DOWN: 'ATK_DOWN',   // 攻撃↓ - 攻撃力-20%
  DEF_DOWN: 'DEF_DOWN',   // 防御↓ - 防御-20
  SPD_DOWN: 'SPD_DOWN',   // 速度↓ - 速度-20
};

/**
 * 状態異常の強さ分類
 */
export const STATUS_STRENGTH = {
  WEAK: 'WEAK',     // 弱 - 基礎成功率100%
  MEDIUM: 'MEDIUM', // 中 - 基礎成功率85%
  STRONG: 'STRONG', // 強 - 基礎成功率70%
};

/**
 * 状態異常メタデータ
 */
export const STATUS_EFFECT_META = {
  [STATUS_EFFECT_TYPES.BURN]: {
    name: '火傷',
    attribute: '炎',
    strength: STATUS_STRENGTH.MEDIUM,
    baseSuccessRate: 0.85,
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    removeCondition: 'natural', // 自然解除
    description: 'ターン終了時にHP5%ダメージ（スタックで増加）',
  },
  [STATUS_EFFECT_TYPES.FREEZE]: {
    name: '凍結',
    attribute: '水',
    strength: STATUS_STRENGTH.STRONG,
    baseSuccessRate: 0.70,
    defaultDuration: 2,
    stackable: false,
    maxStack: 1,
    removeCondition: 'damage', // ダメージで解除
    description: '行動不能、被ダメージ+25%',
  },
  [STATUS_EFFECT_TYPES.PARALYSIS]: {
    name: '麻痺',
    attribute: '光',
    strength: STATUS_STRENGTH.STRONG,
    baseSuccessRate: 0.70,
    defaultDuration: 3,
    stackable: false,
    maxStack: 1,
    removeCondition: 'natural',
    description: '50%の確率で行動失敗',
  },
  [STATUS_EFFECT_TYPES.CURSE]: {
    name: '呪い',
    attribute: '闇',
    strength: STATUS_STRENGTH.MEDIUM,
    baseSuccessRate: 0.85,
    defaultDuration: 3,
    stackable: false,
    maxStack: 1,
    removeCondition: 'natural',
    description: '回復効果50%減少',
  },
  [STATUS_EFFECT_TYPES.TIME_STOP]: {
    name: '時止',
    attribute: '未来',
    strength: STATUS_STRENGTH.MEDIUM,
    baseSuccessRate: 0.85,
    defaultDuration: 2,
    stackable: true,
    maxStack: 3,
    removeCondition: 'natural',
    description: '速度-50（スタックで増加）',
  },
  [STATUS_EFFECT_TYPES.POISON]: {
    name: '毒',
    attribute: '原始',
    strength: STATUS_STRENGTH.WEAK,
    baseSuccessRate: 1.00,
    defaultDuration: -1, // 永続（戦闘終了までリセットなし）
    stackable: true,
    maxStack: 3,
    removeCondition: 'heal_or_cure', // 回復/万能薬で解除
    description: 'ターン終了時にHP3%ダメージ（永続、スタックで増加）',
  },
  [STATUS_EFFECT_TYPES.EXHAUST]: {
    name: '虚脱',
    attribute: null,
    strength: STATUS_STRENGTH.MEDIUM,
    baseSuccessRate: 0.85,
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    removeCondition: 'natural',
    description: '与ダメージ-30%（スタックで増加）',
  },
  [STATUS_EFFECT_TYPES.STUN]: {
    name: 'スタン',
    attribute: null,
    strength: STATUS_STRENGTH.STRONG,
    baseSuccessRate: 0.70,
    defaultDuration: 1,
    stackable: false,
    maxStack: 1,
    removeCondition: 'natural',
    description: '行動不能',
  },
  [STATUS_EFFECT_TYPES.SILENCE]: {
    name: '沈黙',
    attribute: null,
    strength: STATUS_STRENGTH.MEDIUM,
    baseSuccessRate: 0.85,
    defaultDuration: 2,
    stackable: false,
    maxStack: 1,
    removeCondition: 'natural',
    description: 'スキル使用不可',
  },
  [STATUS_EFFECT_TYPES.ATK_DOWN]: {
    name: '攻撃↓',
    attribute: null,
    strength: STATUS_STRENGTH.WEAK,
    baseSuccessRate: 1.00,
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    removeCondition: 'natural',
    description: '攻撃力-20%（スタックで増加）',
  },
  [STATUS_EFFECT_TYPES.DEF_DOWN]: {
    name: '防御↓',
    attribute: null,
    strength: STATUS_STRENGTH.WEAK,
    baseSuccessRate: 1.00,
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    removeCondition: 'natural',
    description: '防御-20（スタックで増加）',
  },
  [STATUS_EFFECT_TYPES.SPD_DOWN]: {
    name: '速度↓',
    attribute: null,
    strength: STATUS_STRENGTH.WEAK,
    baseSuccessRate: 1.00,
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    removeCondition: 'natural',
    description: '速度-20（スタックで増加）',
  },
};

/**
 * ティア耐性値
 */
export const TIER_RESISTANCE = {
  S: 0.20,
  A: 0.15,
  B: 0.10,
  C: 0.05,
  D: 0.00,
};

/**
 * 属性耐性値
 */
export const ATTRIBUTE_RESISTANCE = {
  same: 0.30,       // 同属性: -30%
  advantage: 0.15,  // 有利属性: -15%
  disadvantage: -0.15, // 不利属性: +15%（かかりやすい）
};

/**
 * スタック効果量
 */
export const STACK_EFFECTS = {
  [STATUS_EFFECT_TYPES.BURN]: {
    1: { hpPercent: 0.05 },    // 5%/ターン
    2: { hpPercent: 0.10 },    // 10%/ターン
    3: { hpPercent: 0.15 },    // 15%/ターン
  },
  [STATUS_EFFECT_TYPES.POISON]: {
    1: { hpPercent: 0.03 },    // 3%/ターン
    2: { hpPercent: 0.06 },    // 6%/ターン
    3: { hpPercent: 0.09 },    // 9%/ターン
  },
  [STATUS_EFFECT_TYPES.TIME_STOP]: {
    1: { speed: -50 },
    2: { speed: -100 },
    3: { speed: -150 },
  },
  [STATUS_EFFECT_TYPES.EXHAUST]: {
    1: { damageMultiplier: 0.70 },  // -30%
    2: { damageMultiplier: 0.40 },  // -60%
    3: { damageMultiplier: 0.10 },  // -90%
  },
  [STATUS_EFFECT_TYPES.ATK_DOWN]: {
    1: { atkMultiplier: 0.80 },     // -20%
    2: { atkMultiplier: 0.60 },     // -40%
    3: { atkMultiplier: 0.40 },     // -60%
  },
  [STATUS_EFFECT_TYPES.DEF_DOWN]: {
    1: { def: -20 },
    2: { def: -40 },
    3: { def: -60 },
  },
  [STATUS_EFFECT_TYPES.SPD_DOWN]: {
    1: { speed: -20 },
    2: { speed: -40 },
    3: { speed: -60 },
  },
};

/**
 * 状態異常アイコン
 */
export const STATUS_ICONS = {
  [STATUS_EFFECT_TYPES.BURN]: '🔥',
  [STATUS_EFFECT_TYPES.FREEZE]: '❄️',
  [STATUS_EFFECT_TYPES.PARALYSIS]: '⚡',
  [STATUS_EFFECT_TYPES.CURSE]: '💀',
  [STATUS_EFFECT_TYPES.TIME_STOP]: '⏱️',
  [STATUS_EFFECT_TYPES.POISON]: '☠️',
  [STATUS_EFFECT_TYPES.EXHAUST]: '😩',
  [STATUS_EFFECT_TYPES.STUN]: '💫',
  [STATUS_EFFECT_TYPES.SILENCE]: '🤐',
  [STATUS_EFFECT_TYPES.ATK_DOWN]: '⬇️',
  [STATUS_EFFECT_TYPES.DEF_DOWN]: '🛡️⬇️',
  [STATUS_EFFECT_TYPES.SPD_DOWN]: '🐢',
};

/**
 * ヘルパー関数: 状態異常メタデータ取得
 */
export const getStatusMeta = (type) => STATUS_EFFECT_META[type] || null;

/**
 * ヘルパー関数: 状態異常名取得
 */
export const getStatusName = (type) => STATUS_EFFECT_META[type]?.name || type;

/**
 * ヘルパー関数: 状態異常アイコン取得
 */
export const getStatusIcon = (type) => STATUS_ICONS[type] || '❓';

/**
 * ヘルパー関数: スタック効果取得
 */
export const getStackEffect = (type, stack) => {
  const effects = STACK_EFFECTS[type];
  if (!effects) return null;
  return effects[Math.min(stack, 3)] || effects[1];
};

/**
 * ヘルパー関数: 行動不能かどうか
 */
export const isIncapacitated = (type) => {
  return type === STATUS_EFFECT_TYPES.FREEZE || type === STATUS_EFFECT_TYPES.STUN;
};

/**
 * ヘルパー関数: スキル使用不可かどうか
 */
export const isSilenced = (type) => {
  return type === STATUS_EFFECT_TYPES.SILENCE;
};
